<!-- Container -->
<div class="kt-container-fixed flex flex-wrap items-center justify-between gap-2.5">
	<div class="flex flex-wrap items-center gap-3 lg:gap-5">
		<h1 class="text-lg font-medium text-mono">Dashboard</h1>
		<div class="flex items-center gap-1 text-sm font-normal">
			<a class="hover:text-primary text-secondary-foreground" href="#">Home</a>
			<span class="text-secondary-foreground">/</span>
			<a class="hover:text-primary text-secondary-foreground" href="#">Account</a>
			<span class="text-secondary-foreground">/</span>
			<span class="text-mono">Dashboard</span>
		</div>
	</div>
	<div class="flex items-center gap-1">
		<a class="kt-btn kt-btn-outline" href="#">View Profile</a>
	</div>
</div>
<!-- End of Container -->
